module.exports = __webpack_public_path__ + "static/soc2-9dc36727ec7205dbd46a9d99230a678e.png";